module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-menu"
  }, [_c('i', {
    staticClass: "search-icon u-ico-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }],
    ref: "inputPesquisa",
    staticClass: "pesquisa",
    attrs: {
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "keyup": _vm.pesquisaUsuario,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-560766c6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/chat/components/ChatMenuOptions.vue
// module id = 1672
// module chunks = 17